import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          Brian Dawson
        </div>
        <div className={styles.right}>
          Brian Dawson, 2024&ndash;2026. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
